export const INDUSTRY_CREATIVE_TYPES = ["banner", "native", "video"] as const;
export type IndustryCreativeType = (typeof INDUSTRY_CREATIVE_TYPES)[number];

export const isIndustryCreativeType = (value: string | undefined): value is IndustryCreativeType =>
    (INDUSTRY_CREATIVE_TYPES as readonly string[]).includes(value ?? "");
